export default "__VITE_ASSET__c33e45d7__"